import { REMOTE_FILTERS } from '@entities/participants';

export const mapRemoteFilterToValue = (remoteFilter?: REMOTE_FILTERS) => {
  switch (remoteFilter) {
    case REMOTE_FILTERS.REMOTE:
      return true;
    case REMOTE_FILTERS.OFFICE:
      return false;
    case REMOTE_FILTERS.ALL:
    default:
      return undefined;
  }
};
